export const SUBSCRIPTION_PLANS = [
  {
    id: "plan-filmes-series-monthly",
    title: "Filmes e Séries",
    price: "R$ 150",
    amount: 150,
    period: "por 30 dias",
    featured: true,
    badge: "Mais Escolhido",
    cta: "Assinar por 30 dias",
    desc: "Sincronização ilimitada e automática de filmes e séries para 1 servidor.",
  },
  {
    id: "plan-filmes-monthly",
    title: "Filmes",
    price: "R$ 80",
    amount: 80,
    period: "por 30 dias",
    featured: false,
    cta: "Assinar por 30 dias",
    desc: "Sincronização ilimitada e automática de filmes para 1 servidor.",
  },
  {
    id: "plan-series-monthly",
    title: "Séries",
    price: "R$ 80",
    amount: 80,
    period: "por 30 dias",
    featured: false,
    cta: "Assinar por 30 dias",
    desc: "Sincronização ilimitada e automática de séries para 1 servidor.",
  },
];

export const ONETIME_PLANS = [
  {
    id: "plan-filmes-series-once",
    title: "Filmes e Séries",
    price: "R$ 70",
    amount: 70,
    period: "1 sincronia",
    featured: true,
    badge: "Melhor Custo",
    cta: "Comprar 1 Sincronia",
    desc: "Essa opção permite você sincronizar 1 vez para 1 servidor por 24 horas.",
    info: "Depois de 24 horas você precisará comprar outra sincronia caso queira usar novamente o script.",
  },
  {
    id: "plan-filmes-once",
    title: "Filmes",
    price: "R$ 50",
    amount: 50,
    period: "1 sincronia",
    featured: false,
    cta: "Comprar 1 Sincronia",
    desc: "Essa opção permite você sincronizar 1 vez para 1 servidor por 24 horas.",
    info: "Depois de 24 horas você precisará comprar outra sincronia caso queira usar novamente o script.",
  },
  {
    id: "plan-series-once",
    title: "Séries",
    price: "R$ 50",
    amount: 50,
    period: "1 sincronia",
    featured: false,
    cta: "Comprar 1 Sincronia",
    desc: "Essa opção permite você sincronizar 1 vez para 1 servidor por 24 horas.",
    info: "Depois de 24 horas você precisará comprar outra sincronia caso queira usar novamente o script.",
  },
];

export const ALL_PLANS = [...SUBSCRIPTION_PLANS, ...ONETIME_PLANS];
